import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function DeployPhaseIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8238_13608)">
        <path
          d="M16.167 16.3164C16.5809 16.3166 16.9167 16.6525 16.917 17.0664V17.417C16.9168 17.8309 16.5809 18.1668 16.167 18.167C15.7529 18.167 15.4172 17.831 15.417 17.417V17.0664C15.4172 16.6524 15.7529 16.3164 16.167 16.3164Z"
          fill="currentColor"
        />
        <path
          d="M14.3564 15.5176C14.7025 15.36 15.1187 15.4868 15.3145 15.8223C15.51 16.1576 15.4156 16.5819 15.1084 16.8057L15.0439 16.8477L14.7441 17.0234L14.6758 17.0586C14.3299 17.2155 13.9143 17.0881 13.7188 16.7529C13.5102 16.3953 13.6309 15.9364 13.9883 15.7275L14.2881 15.5527L14.3564 15.5176Z"
          fill="currentColor"
        />
        <path
          d="M17.0195 15.8223C17.2152 15.487 17.6306 15.3602 17.9766 15.5176L18.0449 15.5527L18.3447 15.7275L18.4092 15.7695C18.7161 15.9933 18.8106 16.4177 18.6152 16.7529C18.4066 17.1106 17.9466 17.2318 17.5889 17.0234L17.2891 16.8477L17.2246 16.8057C16.9176 16.5819 16.824 16.1576 17.0195 15.8223Z"
          fill="currentColor"
        />
        <path
          d="M17.6572 13.6094C18.0033 13.4519 18.4195 13.5786 18.6152 13.9141C18.8104 14.2493 18.7162 14.6738 18.4092 14.8975L18.3447 14.9395L18.0449 15.1152L17.9766 15.1504C17.6307 15.3075 17.2153 15.1797 17.0195 14.8447C16.8109 14.487 16.9314 14.0281 17.2891 13.8193L17.5889 13.6445L17.6572 13.6094Z"
          fill="currentColor"
        />
        <path
          d="M13.7188 13.9141C13.9144 13.5788 14.3299 13.4521 14.6758 13.6094L14.7441 13.6445L15.0439 13.8193L15.1084 13.8613C15.4156 14.085 15.5099 14.5094 15.3145 14.8447C15.1056 15.2022 14.6457 15.3239 14.2881 15.1152L13.9883 14.9395L13.9238 14.8975C13.617 14.6737 13.5235 14.2493 13.7188 13.9141Z"
          fill="currentColor"
        />
        <path
          d="M16.167 12.5C16.5809 12.5002 16.9167 12.8361 16.917 13.25V13.6006C16.9167 14.0144 16.5809 14.3504 16.167 14.3506C15.753 14.3506 15.4173 14.0145 15.417 13.6006V13.25C15.4172 12.836 15.7529 12.5 16.167 12.5Z"
          fill="currentColor"
        />
        <path
          d="M6.49902 13.8877C6.79385 13.6473 7.23853 13.6411 7.53809 13.9219C7.54495 13.9282 7.55291 13.9338 7.55957 13.9404L7.56445 13.9463L7.57324 13.9541L7.59375 13.9795C7.8673 14.2908 7.8568 14.7633 7.55957 15.0605C7.25006 15.37 6.749 15.3699 6.43945 15.0605C6.13008 14.751 6.13003 14.2499 6.43945 13.9404L6.49902 13.8877Z"
          fill="currentColor"
        />
        <path
          d="M6.49902 7.2207C6.79385 6.98042 7.23856 6.97415 7.53809 7.25488C7.54499 7.26129 7.55285 7.26673 7.55957 7.27344L7.56445 7.2793L7.57324 7.28711L7.59375 7.3125C7.86744 7.62374 7.85678 8.09626 7.55957 8.39355C7.25001 8.70311 6.74901 8.70311 6.43945 8.39355C6.13006 8.08398 6.12995 7.58294 6.43945 7.27344L6.49902 7.2207Z"
          fill="currentColor"
        />
        <path
          d="M15.4102 7.08789C15.7881 7.12653 16.083 7.44583 16.083 7.83398C16.0827 8.22187 15.7879 8.54149 15.4102 8.58008L15.333 8.58398H10.333C9.91916 8.58381 9.58336 8.24779 9.58301 7.83398C9.58301 7.41988 9.91894 7.08416 10.333 7.08398H15.333L15.4102 7.08789Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.334 3.75C17.5886 3.75035 19.4168 5.57833 19.417 7.83301C19.417 9.01247 18.915 10.0737 18.1152 10.8193C19.8613 11.574 21.083 13.3112 21.083 15.334C21.0827 18.0485 18.8826 20.2498 16.167 20.25C14.6984 20.25 13.3806 19.605 12.4795 18.584H7C4.74521 18.5838 2.91717 16.7548 2.91699 14.5C2.9171 13.1236 3.59792 11.9057 4.6416 11.166C3.59821 10.4261 2.91699 9.20928 2.91699 7.83301C2.91717 5.57822 4.74521 3.75018 7 3.75H15.334ZM16.167 11.917C14.2804 11.917 12.75 13.4474 12.75 15.334C12.7504 17.2203 14.2806 18.75 16.167 18.75C18.054 18.7498 19.5827 17.2203 19.583 15.334C19.583 13.4474 18.0542 11.9172 16.167 11.917ZM6.73535 11.9297C5.43312 12.0622 4.41716 13.1629 4.41699 14.5C4.41717 15.9264 5.57364 17.0838 7 17.084H11.5723C11.3649 16.5402 11.2501 15.9506 11.25 15.334C11.25 15.306 11.2515 15.2778 11.252 15.25H10.333C9.91905 15.2498 9.58318 14.914 9.58301 14.5C9.58318 14.086 9.91905 13.7502 10.333 13.75H11.5127C11.7487 13.0563 12.1344 12.4324 12.6328 11.917H7L6.73535 11.9297ZM7 5.25C5.57364 5.25018 4.41717 6.40665 4.41699 7.83301C4.41699 9.25952 5.57353 10.4168 7 10.417H15.334C16.7603 10.4166 17.917 9.25941 17.917 7.83301C17.9168 6.40675 16.7602 5.25035 15.334 5.25H7Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_8238_13608">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
